import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-three-one-one-one',
  templateUrl: './three-one-one-one.component.html',
  styleUrls: ['./three-one-one-one.component.scss']
})
export class ThreeOneOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
